import { gql } from "@apollo/client"
import { PLAN_CONTRIBUTION_SETTINGS_FRAGMENT } from "~/shared/fragments/PlanContributionSettingFragment"

export const PLAN_FRAGMENT = gql`
  ${PLAN_CONTRIBUTION_SETTINGS_FRAGMENT}
  fragment PlanFragment on BenefitsPlan {
    id
    name
    category
    guideUrl
    coverageTypes
    descriptiveName
    ...PlanContributionSettingFragment
    provider {
      id
      name
      automated
    }
    fee(engagementId: $engagementId, useSalaryCurrencyCode: $useSalaryCurrencyCode) {
      subunit
      formatted
      currencyCode
    }
    priceEstimate(currencyCode: $currencyCode, engagementType: $engagementType) {
      id
      isDefault
      currencies {
        subunit
        formatted
        currencyCode
        subunitToUnit
      }
    }
  }
`
